import axios from 'axios'
import advisor from './advisor'
import user from './user'

const bmc = { 
  advisor,
  user,
  properties:{
    getProperties: (planid='') => {
      if (planid==='') {
        return axios.get(`${process.env.REACT_APP_API_URL}bmc/Properties`).then(res => res.data)
      } else {
        return axios.get(`${process.env.REACT_APP_API_URL}bmc/Properties?planID=${planid}`).then( res => res.data )
      }
    },
    postProperty: data => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/Property`, data
    ).then(res => res.data),
    deleteProperty: data => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/delete`, data
    ).then(res => res.data),
  },
  savings:{
    getSavings: (planid='') => {
      if (planid==='') {
        return axios.get(`${process.env.REACT_APP_API_URL}bmc/Savings`).then(res => res.data)
      } else {
        return axios.get(`${process.env.REACT_APP_API_URL}bmc/Savings?planID=${planid}`).then(res => res.data)
      }
    },
    getSavingsAsOf: (year, planid) => axios.get(
      `${process.env.REACT_APP_API_URL}bmc/SavingsAsOf?year=${year}&planID=${planid}`
    ).then(res => res.data),
    postSaving: data => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/Saving`, data
    ).then( res => res.data ),
    deleteSaving: data => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/delete`, data
    ).then(res => res.data),
    getRateVariations: (planid) => axios.get(
      `${process.env.REACT_APP_API_URL}bmc/RateVariations?planID=${planid}`
    ).then(res => res.data),
    postRateVariations: data => {
      return axios.post(
      `${process.env.REACT_APP_API_URL}bmc/RateVariations`, data
      ).then( res => res.data )},
    putRateVariations: data => axios.put(
      `${process.env.REACT_APP_API_URL}bmc/RateVariations`, data
      ).then( res => res.data ),
  },
  debts:{
    getDebts: (planid='') => {
      if (planid==='') {
        return axios.get(`${process.env.REACT_APP_API_URL}bmc/Debts`).then(res => res.data)
      } else {
        return axios.get(`${process.env.REACT_APP_API_URL}bmc/Debts?planID=${planid}`).then(res => res.data)
      }
    },
    getDebtsAsOf: (year, planid) => axios.get(
      `${process.env.REACT_APP_API_URL}bmc/DebtsAsOf?year=${year}&planID=${planid}`
    ).then(res => res.data),
    getDebt: id => axios.get(
      `${process.env.REACT_APP_API_URL}bmc/Debt?id=${id}`
    ).then( res => res.data ),
    postDebt: data => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/Debt`, data
    ).then( res => res.data ),
    deleteDebt: data => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/delete`, data
    ).then(res => res.data)
  },
  income:{
    getIncomes: (planid='') => {
      if (planid==='') {
        return axios.get(`${process.env.REACT_APP_API_URL}bmc/Incomes`).then(res => res.data)
      } else {
        return axios.get(`${process.env.REACT_APP_API_URL}bmc/Incomes?planID=${planid}`).then(res => res.data)
      }
    },
    postIncome: data => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/Income`, data
    ).then( res => res.data ),
    deleteIncome: data => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/delete`, data
    ).then(res => res.data),
  },
  events: {
    getEvents:  (planid='') => {
      if (planid==='') {
        return axios.get(`${process.env.REACT_APP_API_URL}bmc/LifeEvents`).then(res => res.data)
      } else {
        return axios.get(`${process.env.REACT_APP_API_URL}bmc/LifeEvents?planID=${planid}`).then(res => res.data)
      }
    },
    postEvent: data => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/LifeEvent`, data
    ).then( res => res.data ),
    deleteEvent: data => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/delete`, data
    ).then(res => res.data),
  },
  expenses: {
    getExpenses:  (planid='') => {
      if (planid==='') {
        return axios.get(`${process.env.REACT_APP_API_URL}bmc/Expenses`).then(res => res.data)
      } else {
        return axios.get(`${process.env.REACT_APP_API_URL}bmc/Expenses?planID=${planid}`).then(res => res.data)
      }
    },
    postExpense: data => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/Expense`, data
    ).then( res => res.data ),
    postOpCosts: data => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/OpCosts`, data
    ).then( res => res.data ),
    deleteExpense: data => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/delete`, data
    ).then(res => res.data),
  },
  activities: {
    getActivities: (planid='', type='') => {
      if (planid==='') {
        return axios.get(`${process.env.REACT_APP_API_URL}bmc/Activities`).then(res => res.data)
      } else if (type==='') {
        return axios.get(`${process.env.REACT_APP_API_URL}bmc/Activities?planID=${planid}`).then(res => res.data)
      } else {
        return axios.get(`${process.env.REACT_APP_API_URL}bmc/Activities?planID=${planid}&type=${type}`).then(res => res.data)
      }
    },
    postActivity: data => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/Activity`, data
    ).then( res => res.data ),
    deleteActivity: data => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/delete`, data
    ).then(res => res.data),
  },
  faq: {
    getFAQ: () => axios.get(
      `${process.env.REACT_APP_API_URL}bmc/FAQ`
    ).then(res => res.data),
    searchFAQ: q => axios.get(
      `${process.env.REACT_APP_API_URL}bmc/FAQ?q=${q}`
    ).then(res => res.data),
  },
  dashboard: {
    getUserSummary: () => axios.get(`${process.env.REACT_APP_API_URL}bmc/UserSummary`)
    .then(res => {
      return res.data
    }),
    getLastAssessment: (planid='') => {
      if (planid==='') {
        return axios.get(`${process.env.REACT_APP_API_URL}bmc/LastAssessment`).then(res => res.data)
      } else {
        return axios.get(`${process.env.REACT_APP_API_URL}bmc/LastAssessment?planID=${planid}`).then(res => res.data)
      }
    }
  },
  plans:{
    getPlans: () => axios.get(
      `${process.env.REACT_APP_API_URL}bmc/plans`
    ).then(res => res.data),
    savePlans: (plans) => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/plans`, plans
    ).then(res => res.data),
    getPlanData: id => axios.get(
      `${process.env.REACT_APP_API_URL}bmc/plan?id=${id}`
    ).then(res => res.data),
    savePlan: plan => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/plan`, plan
    ).then(res => res.data),     
    planAction: action => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/PlanAction?action=${action}`
    ).then( res => res.data ),
  },
  report:{
    getReport: (type, planid) => axios.get(
      `${process.env.REACT_APP_API_URL}bmc/Data?planID=${planid}&type=${type}`
    ).then(res => res.data),
    getComparePlans: (type) => axios.get(
      `${process.env.REACT_APP_API_URL}bmc/ComparePlans?type=${type}`
    ).then(res => res.data),
    getExcel: (type, planid) => axios.get(
      `${process.env.REACT_APP_API_URL}bmc/Data?planID=${planid}&type=${type}`,
        {responseType: 'blob'}
    ).then(res => res.data),
    allocateSurplus: data => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/AllocateSurplus`, data)
  },
  stats:{
    assessPlan: (planid) => axios.get(
      `${process.env.REACT_APP_API_URL}bmc/AssessPlan?id=${planid}`
    ).then(res => res.data),
    getUserBaseline: () => axios.get(
      `${process.env.REACT_APP_API_URL}bmc/UserBaseline`
    ).then(res => res.data),
    updateBaseline: () => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/UpdateBaseline`
    ).then( res => res.data )
  },
  rollover: {
    getRollover: () => axios.get(
      `${process.env.REACT_APP_API_URL}bmc/Rollover`
    ).then( res => res.data),
    processRollover: (data) => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/ProcessRollover`, data
    ).then( res => res.data),
  },
  wizard: {
    getWizardTaxes: (primary, partner) => axios.get(
      `${process.env.REACT_APP_API_URL}bmc/WizardTaxes?primary=${primary}&partner=${partner}`
    ).then(res => res.data),
    getWizardLifestyle: () => axios.get(
      `${process.env.REACT_APP_API_URL}bmc/WizardLifestyle`
    ).then(res => res.data),
    getPropertyTax: (prov) => axios.get(
      `${process.env.REACT_APP_API_URL}bmc/PropertyTax?prov=${prov}`
    ).then( res => res.data ),
    wizardComplete: (data) => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/WizardComplete`, data
    ).then( res => res.data ),
    wizardActivities: (data) => axios.post(
      `${process.env.REACT_APP_API_URL}bmc/WizardActivities`, data
    ).then( res => res.data ),
  },
}
export default bmc